import authHeader from "./auth-header";

export default function httpConfig() {
    return {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': authHeader()
        }
    };
}